import { render, staticRenderFns } from "./HCProjectSettings.vue?vue&type=template&id=4b384833&scoped=true&"
import script from "./HCProjectSettings.vue?vue&type=script&lang=js&"
export * from "./HCProjectSettings.vue?vue&type=script&lang=js&"
import style0 from "./HCProjectSettings.vue?vue&type=style&index=0&id=4b384833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b384833",
  null
  
)

export default component.exports